import { createSlice } from '@reduxjs/toolkit';
import { CompactiveEffort } from 'Components/Worksheets/ConvertedWetDensityWorksheet/types';
import moment from 'moment';
import * as oPath from '../../../Lib/Object/Path/Mutable';
import { SetValueAction } from '../DataSync/types';
import {
  GetAvailableMaximumDryDensityTestsAction,
  GetAvailableMaximumDryDensityTestsResolveAction,
  GetSourceEntitiesAction,
  GetSourceEntitiesResolveAction,
  IAssignedMaximumDryDensityState,
  PostSelectedTestsResultsResolveAction,
  SetTestSelected,
} from './types';

const name = 'assignedMaximumDryDensityTests';

const initialState: IAssignedMaximumDryDensityState = {
  query: {
    params: {
      DateSampledFrom: String(),
      DateSampledTo: String(),
      Project: undefined,
      Material: undefined,
      Source: undefined,
      CompactionMethod: CompactiveEffort.Standard,
    },
  },
  mddTests: undefined,
  results: undefined,
  status: {
    creating: false,
    calculating: false,
    querying: false,
    loadingEntities: false,
  },
  assignedDate: String(),
  sourceEntities: [],
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    init: (state) => {
      state.mddTests = undefined;
      state.results = undefined;
      state.assignedDate = moment().format('YYYY-MM-DDTHH:mm:ss.SSS');
    },
    getAvailableMddsReject: (state) => {
      state.status.querying = false;
    },
    getAvailableMddsResolve: (state, action: GetAvailableMaximumDryDensityTestsResolveAction) => {
      state.mddTests = action.payload;
      state.status.querying = false;
    },
    getAvailableMdds: (state, action: GetAvailableMaximumDryDensityTestsAction) => {
      state.status.querying = true;
    },
    createAssignedValueTestReject: (state) => {
      state.status.creating = false;
    },
    createAssignedValueTestResolve: (state) => {
      //Clear selected tests
      state.mddTests?.Worksheets.forEach((s) => (s.selected = false));
      state.status.creating = false;
    },
    createAssignedValueTest: (state) => {
      state.status.creating = true;
    },
    setTestSelected: (state, action: SetTestSelected) => {
      const { payload: { index, value } = {} } = action;
      oPath.set(state.mddTests?.Worksheets, `${index}.selected`, value);
    },
    setValue: (state, action: SetValueAction) => {
      const { payload: { name, value } = {} } = action;
      oPath.set(state, name, value, true);
    },
    postSelectedTestsResults: (state) => {
      state.status.calculating = true;
    },
    postSelectedTestsResultsResolve: (state, action: PostSelectedTestsResultsResolveAction) => {
      const {
        payload: { results, messages },
      } = action;
      state.results = results;
      state.results.Messages = messages;
      state.status.calculating = false;
    },
    postSelectedTestsResultsReject: (state) => {
      state.status.calculating = false;
    },
    postSelectedTestsResultsCleanup: (state) => {
      state.status.calculating = false;
      state.results = undefined;
    },
    cleanupSourceEntities: (state) => {
      state.status.querying = false;
      state.sourceEntities = undefined;
    },
    getSourceEntities: (state, action: GetSourceEntitiesAction) => {
      state.status.loadingEntities = true;
    },
    getSourceEntitiesResolve: (state, action: GetSourceEntitiesResolveAction) => {
      state.sourceEntities = action.payload;
      state.status.loadingEntities = false;
    },
    getSourceEntitiesReject: (state) => {
      state.sourceEntities = undefined;
      state.status.loadingEntities = false;
    },
  },
});

const { actions: sliceActions, reducer } = slice;
const actions = {
  ...sliceActions,
};
export { actions, reducer };
